import * as soleProprietorshipApi from '../../api/soleProprietorship'

async function searchSoleProprietorship({ commit }, searchParams) {
  try {
    const matchingSoleProprietorships = await soleProprietorshipApi.searchSoleProprietorship(searchParams)
    commit('setMatchingSoleProprietorships', matchingSoleProprietorships)
    this.commit('setUserRateLimited', false)
  } catch (err) {
    if (err.response.status == 429) {
      this.dispatch('notify', {
        newNotification: {
          type: 'warning',
          message: 'Sajnos túllépte a napi keresési limitet. Kérjük próbálja meg később újból.'
        }
      })
      this.commit('setUserRateLimited', true)
    }
    commit('setMoreResultCount', 1)
  }
}

// eslint-disable-next-line no-unused-vars
async function getSoleProprietorship({ dispatch, commit }, getParams) {
  try {
    const soleProprietorship = await soleProprietorshipApi.getSoleProprietorship(getParams)
    commit('setSelectedSoleProprietorship', soleProprietorship)
    //dispatch('notify', { newNotification: { type: 'success', message: 'Cég adatai sikeresen beolvasva.' } })
    this.commit('setUserRateLimited', false)
    this.commit('setInvalidSoleProprietorshipTaxNumber', false)
  } catch (err) {
    if (err.response.status == 429) {
      this.dispatch('notify', {
        newNotification: {
          type: 'warning',
          message: 'Sajnos túllépte a napi keresési limitet. Kérjük próbálja meg később újból.'
        }
      })
      this.commit('setUserRateLimited', true)
    }
    if (err.response.status == 400) {
      this.dispatch('notify', {
        newNotification: {
          type: 'error',
          message: 'A megadott keresési szempont alapján nem található egyéni vállalkozó a nyilvántartásban.'
        }
      })
      this.commit('setInvalidSoleProprietorshipTaxNumber', true)
    }
  }
}

function setMatchingSoleProprietorships(state, matchingSoleProprietorships) {
  state.matchingSoleProprietorships = matchingSoleProprietorships
}

function setSelectedSoleProprietorship(state, selectedSoleProprietorship) {
  state.selectedSoleProprietorship = selectedSoleProprietorship
}

function setMoreResultCount(state, moreResultCount) {
  state.moreResultCount = moreResultCount
}

function setSoleProprietorshipSearchTerm(state, searchTerm) {
  state.searchTerm = searchTerm
}

function setInvalidSoleProprietorshipTaxNumber(state, invalidTaxNumber) {
  state.invalidTaxNumber = invalidTaxNumber
}

function nullifySoleProprietorShipSuggestionsAction({ commit }) {
  commit('nullifySoleProprietorShipSuggestions')
}

function nullifySoleProprietorShipSuggestions(state) {
  state.matchingSoleProprietorships = []
}

const soleProprietorshipStore = {
  state: {
    matchingSoleProprietorships: [],
    selectedSoleProprietorship: null,
    moreResultCount: 5,
    searchTerm: '',
    invalidTaxNumber: false
  },
  actions: {
    getSoleProprietorship,
    searchSoleProprietorship,
    nullifySoleProprietorShipSuggestionsAction
  },
  mutations: {
    setMatchingSoleProprietorships,
    setSelectedSoleProprietorship,
    setMoreResultCount,
    setSoleProprietorshipSearchTerm,
    setInvalidSoleProprietorshipTaxNumber,
    nullifySoleProprietorShipSuggestions
  },
  getters: {
    soleProprietorshipSuggestions: state => {
      return { data: state.matchingSoleProprietorships }
    },
    selectedSoleProprietorship: state => {
      return state.selectedSoleProprietorship
    },
    getMoreResultCount: state => {
      return state.moreResultCount
    },
    getSoleProprietorshipSearchTerm: state => {
      return state.searchTerm
    },
    invalidTaxNumber: state => {
      return state.invalidTaxNumber
    }
  }
}

export default soleProprietorshipStore
